import {ApiClient} from "../../utils/ApiClient";

export default class PaymentMethod extends ApiClient {
    static resourceName = 'payment_methods';
}
